import { getDate } from '@progress/kendo-date-math';
/**
 * @hidden
 */

export var isInRange = function isInRange(candidate, min, max) {
  return candidate === null || !(min && getDate(min) > getDate(candidate) || max && getDate(max) < getDate(candidate));
};